/* eslint-disable default-param-last */
import merge from 'deepmerge';
import {
  getFromSession,
  saveToSession,
  deleteFromSession,
  makeUpObj,
  getByDotNotation,
  deleteByDotNotation,
  getCreativitiesList,
  getCreativityDraftInfo,
  compareObjects,
  sortObjectByKeys,
  CREATIVITY_LIST,
} from '@gerenciatd/next.utils.custo';
const HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';


export const types = {
  GET_CREATIVITY: 'CUSTO/GET_CREATIVITY',
  SET_CREATIVITY: 'CUSTO/SET_CREATIVITY',
  UPDATE_CREATIVITY: 'CUSTO/UPDATE_CREATIVITY',
  SET_DRAFT_CHANGE: 'CUSTO/SET_DRAFT_CHANGE',
  SET_EDIT_MODE: 'CUSTO/SET_EDIT_MODE',
  APPLY_SESSION_DRAFT: 'CUSTO/APPLY_SESSION_DRAFT',
  APPLY_SESSION_DRAFT_CLIENT: 'CUSTO/APPLY_SESSION_DRAFT_CLIENT',
  LIST_CHANGES: 'CUSTO/LIST_CHANGES',
  RESET_CREATIVITY_OVERRIDE: 'CUSTO/RESET_CREATIVITY_OVERRIDE',
  SET_CREATIVITY_OVERRIDE: 'CUSTO/SET_CREATIVITY_OVERRIDE',
  DELETE_NODE: 'CUSTO/DELETE_NODE',
  ADD_NODE: 'CUSTO/ADD_NODE',
  RESORT_NODE: 'RESORT_NODE',
  SET_CUSTO_PARAMS: 'CUSTO/SET_CUSTO_PARAMS' 
};

export const initialState = {
  // info
  creativities: {}, // real info from custo
  creativitiesOverride: {}, // merged
  differences: null,
  // flags
  custoParams: null,
  editMode: false,
  allowEdit: `${process.env.NEXT_PUBLIC_ALLOW_EDIT}` === 'true'
};


const CustoReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      const { custo } = action.payload;
      const nextState = merge(state, custo);
      return nextState;
    }
    case types.SET_CUSTO_PARAMS: {
      const { data } = action;
      return {
        ...state,
        custoParams: data,
      }
    }
    case types.RESET_CREATIVITY_OVERRIDE: {
      const { creativityId } = action;

      if (creativityId === 'all') {
        const creativities = getFromSession(CREATIVITY_LIST);
        creativities.forEach(creativityId => {
          deleteFromSession(creativityId);
        })
        return {
          ...state,
          creativitiesOverride: {
            ...state.creativities
          },
        }
      } 

      const newCreativitiesOverride = {
        ...state.creativitiesOverride,
        [creativityId]: { ...state.creativities[creativityId]}
      }
      deleteFromSession(creativityId);

      return {
        ...state,
        creativitiesOverride: newCreativitiesOverride
      }
    }
    case types.SET_CREATIVITY_OVERRIDE: {
      const { creativityId, info } = action.data;
      saveToSession(creativityId, info);
      return {
        ...state,
        creativitiesOverride: {
          ...state.creativitiesOverride,
          [creativityId]: info
        }
      }
    }
    case types.LIST_CHANGES: {
      const creativities = getCreativitiesList();
      const diffResults = {}
      creativities.forEach(creativityId => {
        const originalInfo = state.creativities[creativityId] || {};
        const overrideInfo = state.creativitiesOverride[creativityId] || {};
        diffResults[creativityId] = compareObjects(originalInfo, overrideInfo);
      })
      return {
        ...state,
        differences:diffResults,
      }
    }
    case types.SET_DRAFT_CHANGE: {
      const { value, creativityId, name, entryPoint } = action.data;
      const smallObj = {
        [name]: value,
      }
      const change = makeUpObj(entryPoint, smallObj);
      // mergeamos con la creatividad
      const lastCreativityDraft = {...state.creativitiesOverride[creativityId]};
      let currentCreativity = merge(
        lastCreativityDraft,
        change,
      );
      // mergeamos con todo
      const newCreativitiesOverride = {
        ...state.creativitiesOverride,
        [creativityId]: {...currentCreativity}
      }
      // guardamos en session
      saveToSession(creativityId, currentCreativity);
      return {
        ...state,
        creativitiesOverride: newCreativitiesOverride
      }
    }
    case types.SET_CREATIVITY: {
      // storing creativity data from custo
      const { data } = action;
      const { creativityId, info } = data;
      return {
        ...state,
        creativities: {
          ...state.creativities,
          [creativityId]: info,
        }
      }
    }
    case types.APPLY_SESSION_DRAFT_CLIENT: {
      
      let creativitiesOverride = {
        ...state.creativitiesOverride,
      };
      const creativities = getCreativityDraftInfo(action.creativityId);
      creativities.forEach(creativityName => {
        let creativityInfo = getFromSession(creativityName);
        if (!creativityInfo) {
          creativityInfo = state.creativities[creativityName]
        }

        creativitiesOverride = {
          ...creativitiesOverride,
          [creativityName]: creativityInfo,
        }

      })
      return {
        ...state,
        creativitiesOverride,
      }
    }
    case types.SET_EDIT_MODE: 
      return {
        ...state,
        editMode: action.flag,
    }
    case types.DELETE_NODE: {
      const {creativityId, entryPoint } = action.data;
      const currentDraft = { ...state.creativitiesOverride[creativityId] }
      const newDraft = deleteByDotNotation(currentDraft, entryPoint);
      const newOverrides = {
        ...state.creativitiesOverride,
        [creativityId]: {...newDraft},
      }
      // guardamos en session
      saveToSession(creativityId, newDraft);
      return {
        ...state,
        creativitiesOverride: {...newOverrides},
      }
    }
    case types.RESORT_NODE: {
      const { creativitiesOverride } = state;
      const {listSorted,  entryPoint , creativityId } = action.data;
      let newCreativitiesOverride = {
        ...creativitiesOverride,
      }
      if (creativitiesOverride && creativitiesOverride[creativityId]) {
        const finalListSorted = listSorted.map(item => item.name)
        let infoData = getByDotNotation(creativitiesOverride[creativityId], entryPoint);
        console.log('entrypoint', { entryPoint });
        console.log('antes:', { infoData })
        const change = makeUpObj(entryPoint, sortObjectByKeys(infoData, finalListSorted));
        newCreativitiesOverride = {
          ...newCreativitiesOverride,
          [creativityId]: {
            ...newCreativitiesOverride[creativityId],
            ...change,
          }
        }
        console.log('después:', {
          change,
          newCreativitiesOverride
        })
      }
      
      return {
        ...state,
        creativitiesOverride: newCreativitiesOverride,
      }
    }

    default:
      return { ...state };
  }
};

export const actions = {
  /* operations */
  setCustoParams: (data) => ({
    type: types.SET_CUSTO_PARAMS,
    data,
  }),
  getCreativity: (data) => ({
    type: types.GET_CREATIVITY,
    data,
  }),
  setCreativity: (data) => ({
    type: types.SET_CREATIVITY,
    data,
  }),
  setDraftChange: (data) => ({
    type: types.SET_DRAFT_CHANGE,
    data,
  }),
  applySessionDraft: (data) => ({
      type: types.APPLY_SESSION_DRAFT,
      data,
  }),
  applySessionDraftClient: (creativityId) => ({
    type: types.APPLY_SESSION_DRAFT_CLIENT,
    creativityId,
  }),
  setEditMode: flag => ({
    type: types.SET_EDIT_MODE,
    flag,
  }),
  listChanges: () => ({
    type: types.LIST_CHANGES,
  }),
  resetCreativity: (creativityId) => ({
    type: types.RESET_CREATIVITY_OVERRIDE,
    creativityId,
  }),
  updateCreativity: (data) =>({
    type: types.UPDATE_CREATIVITY,
    data,
  }),
  deleteNode: (data) => ({
    type: types.DELETE_NODE,
    data,
  }),
  addNode: (data) => ({
    type: types.ADD_NODE,
    data,
  }),
  resortNode: (data) => ({
    type: types.RESORT_NODE,
    data
  }),
  setCreativityOverride: (data) => ({
    type: types.SET_CREATIVITY_OVERRIDE,
    data,
  })
};

export default CustoReducer;
